import axios from 'axios'
import { getCookies } from './Utility';

 const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
  config => {
    const token = getCookies("auth-token");
    if (token) {
      config.headers['Authorization'] = 'JWT ' + token
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

export default axiosInstance;
